export default {
  GET_ON_BOARDING_INVITATIONS_STATISTICS_QUERY: Symbol.for('GET_ON_BOARDING_INVITATIONS_STATISTICS_QUERY'),
  ON_BOARDING_INVITATIONS_STATISTICS_REPOSITORY: Symbol.for('ON_BOARDING_INVITATIONS_STATISTICS_REPOSITORY'),
  ON_BOARDING_INVITATIONS_STATE_MANAGER: Symbol.for('ON_BOARDING_INVITATIONS_STATE_MANAGER'),
};
